import type { Extra } from '~/utils/error'
import { ErrorWithExtra } from '~/utils/error'

export class ApiToModelError extends ErrorWithExtra {
  constructor(message: string, extra?: Extra) {
    super('ApiToModelError', message, extra)
  }
}
